import React, { useState } from "react";
import "./EditUserModal.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { isValidEmail } from "../../../../utils/validation";

interface EditUserModalProps {
  user: any;
  onClose: () => void;
  onUpdate: (updatedUser: any) => void;
  loading: boolean;
}

const EditUserModal: React.FC<EditUserModalProps> = ({
  user,
  onClose,
  onUpdate,
  loading,
}) => {
  const [formData, setFormData] = useState({
    firstName: user.firstName || "",
    lastName: user.lastName || "",
    email: user.email || "",
    mobileNumber: user.mobileNumber || "",
  });
  const [emailError, setEmailError] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (name === "email") {
      setEmailError("");
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePhoneChange = (value: string) => {
    const trimmedValue = value.slice(0, 15);

    setFormData((prev) => ({
      ...prev,
      mobileNumber: trimmedValue ? `+${trimmedValue}` : "",
    }));
  };

  const handleSubmit = () => {
    if (!isValidEmail(formData.email)) {
      setEmailError("Please enter a valid email address");
      return;
    }

    onUpdate(formData);
  };

  return (
    <div className="edit-user-backdrop">
      <div className="edit-user-modal">
        <h2>Edit User</h2>

        <div className="edit-user-form-body">
          <div className="edit-user-form-row">
            <div className="edit-user-form-group">
              <label>
                First Name <span>*</span>
              </label>
              <input
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                maxLength={50}
              />
            </div>

            <div className="edit-user-form-group">
              <label>
                Initial <span>*</span>
              </label>
              <input
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                maxLength={2}
              />
            </div>
          </div>

          <div className="edit-user-form-group">
            <label>
              Email Address <span>*</span>
            </label>
            <input
              name="email"
              value={formData.email}
              onChange={handleChange}
              maxLength={60}
              className={emailError ? "edit-user-input-error" : ""}
            />
            {emailError && (
              <span className="edit-user-error-text">{emailError}</span>
            )}
          </div>

          <div className="edit-user-form-group">
            <label>
              Mobile Number <span>*</span>
            </label>
            <PhoneInput
              country={"us"}
              value={formData.mobileNumber.replace(/^\+/, "")}
              onChange={handlePhoneChange}
              inputProps={{
                name: "mobileNumber",
                maxLength: 20,
              }}
              inputStyle={{
                width: "100%",
                height: "50px",
                borderRadius: "8px",
              }}
              containerStyle={{
                width: "100%",
                // marginBottom: "6px",
              }}
              buttonStyle={{
                borderTopLeftRadius: "8px",
                borderBottomLeftRadius: "8px",
              }}
              containerClass="edit-user-phone-input"
              inputClass="edit-user-phone-control"
              buttonClass="edit-user-phone-button"
            />
          </div>
        </div>

        <div className="edit-user-modal-actions">
          <button className="edit-user-btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="edit-user-btn-update" onClick={handleSubmit}>
            {loading ? "Updating..." : "Update"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditUserModal;
